































import {Component, Mixins} from 'vue-property-decorator'
import OrderView from './OrderView.vue'
import OrderCard from '@/components/cards/order/OrderCard.vue'
import PlaceholderCard from '@/components/cards/PlaceholderCard.vue'
import orderByTokenMixin from '@/mixins/orderByTokenMixin'
import {IOrder} from "@/entities";

@Component({
  metaInfo(): Object {
    return {
      title: (this as any).title + ' - '
    }
  },
  components: {
    OrderView,
    OrderCard,
    PlaceholderCard
  }
})
export default class Order extends Mixins(orderByTokenMixin) {

  private DURATION = 500;

  protected initFetches = [
    this.fetchOrderAndShowResult
  ];

  private fetchOrderAndShowResult(): void {
    this.fetchOrderByToken()
      .then(this.checkPaymentResult);
  }

  checkPaymentResult(): void {
    let status = this.$route.query?.payment as string;
    let plan = this.$route.query?.plan;
    if (['paid','error','success','early'].indexOf(status) !== -1) {
      setTimeout(() => {
        this.$storage.actions.setModal({
          name: 'ModalPaymentResult',
          step: plan ? 'plan' : status,
          from: 'order',
          subject: {
            ...this.order,
            name: this.title
          }
        });
      }, this.DURATION)
    } else {
      this.$storage.actions.closeModal();
    }
  }

}
